import { render, staticRenderFns } from "./AircraftDetail.vue?vue&type=template&id=2ca32561&"
import script from "./AircraftDetail.vue?vue&type=script&lang=js&"
export * from "./AircraftDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports